<template>
  <div class="business_tabs">
    <a-tabs type="card">
      <a-tab-pane key="1" tab="子设备层级信息">
        <child-equipment :model="detailChildren"></child-equipment>
      </a-tab-pane>
      <a-tab-pane key="2" tab="父设备层级信息">
        <parent-equipment :model="detailParent" :idOfTheDevice="model.id"></parent-equipment>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import childEquipment from './childEquipment.vue'
import parentEquipment from './parentEquipment.vue'
import { getEquipmentTreeByLevelOneId, getEquipmentTreeByPid } from '@/api/gasEquipmentLedger'
export default {
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        console.log(model)
        if (model) {
          this.initData()
        }
      },
      deep: true,
      immediate: true
    }
  },
  components: {
    childEquipment,
    parentEquipment
  },
  data () {
    return {
      detailChildren: [],
      detailParent: []
    }
  },
  methods: {
    // 获取设备层级信息
    initData () {
      function processingData (data) {
        data.forEach(item => {
          if (item.children.length === 0) {
            delete item.children
          } else {
            processingData(item.children)
          }
        })
      }
      const data = {
        pid: this.model.id
      }
      const data2 = {
        id: this.model.id
      }
      getEquipmentTreeByPid(data).then(res => {
        if (res.status === 0) {
          processingData(res.data)
          this.detailChildren = res.data
        } else {
          this.$message.error(res.info.message)
        }
      }).catch(err => {
        this.$message.error(err.info.message)
      })
      getEquipmentTreeByLevelOneId(data2).then(res => {
        if (res.status === 0) {
          processingData(res.data)
          this.detailParent = res.data
        } else {
          this.$message.error(res.info.message)
        }
      }).catch(err => {
        this.$message.error(err.info.message)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.business_tabs {
  // /deep/.ant-tabs-bar .ant-tabs-nav-container .ant-tabs-tab-active {
  //   background: rgba(255, 255, 255, 1) !important;
  //   font-size: 12px;
  //   color: #08409f !important;
  //   font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  //   font-weight: bold;
  // }
  // /deep/.ant-tabs-bar .ant-tabs-nav-container .ant-tabs-tab {
  //   background: rgba(255, 255, 255, 1) !important;
  //   font-size: 12px;
  //   color: #b3b3b3;
  //   line-height: 18px;
  //   font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  //   font-weight: bold;
  // }
  height: 100%;
  /deep/.ant-tabs {
    height: 100%;
    .ant-tabs-content {
      height: calc(100% - 40px);
    }
  }
  /deep/.ant-tabs-bar {
    border: 0;
    margin-bottom: 0;
    .ant-tabs-nav-container {
      border-bottom: 1px solid #e8e8e8;

      .ant-tabs-tab {
        border: 0;
        height: 26px;
        // line-height: 26px;
        padding: 0 10px;
        margin: 7px 0;
        margin-right: 16px;

        background: rgba(255, 255, 255, 1) !important;
        font-size: 12px;
        color: #b3b3b3;
        line-height: 18px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
      }
      .ant-tabs-tab-active {
        background: rgba(255, 255, 255, 1) !important;
        font-size: 12px;
        color: #08409f !important;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
      }
    }
  }
  /deep/.ant-tabs-content {
    .ant-tabs-tabpane{
      >div{
        margin-left: -1px;
        margin-right: -1px;
        margin-bottom: -1px;
      }
    }
  }
  /deep/ .table {
    .ant-table-thead {
      > tr {
        > th {
          background: rgba(8, 64, 159, 0.1);
          border-right: 1px solid #dddddd;

          .ant-table-header-column {
            font-size: 12px;
            font-family: SourceHanSansCN-Normal, SourceHanSansCN;
            font-weight: 400;
            color: #333333;
            line-height: 18px;
          }
        }
      }
    }
  }
  // /deep/.ant-tabs-tab{
  //   border: 0 !important;
  //   height: 26px !important;
  //   line-height: 26px !important;
  //   padding: 0 10px !important;
  //   margin: 7px 0 !important;
  //   margin-right: 16px !important;
  // }
  // /deep/.ant-tabs-tab-active{
  //   background: rgba(23, 145, 255, 0.1) !important;
  // }
}
</style>
